module.exports = __webpack_public_path__ + "img/组 127@2x(1).fd8e45b0.png";